import { useTranslation } from 'react-i18next';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-3 w-3 border-[1.5px]',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-label={t('loading.default', { defaultValue: 'Loading' })}
      className={`inline-block animate-spin rounded-full border-slate-300 border-t-blue-600 ${SIZE[size]} ${className}`}
    />
  );
}
